var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91463 0.329756C4.6211 0.329756 0.329634 4.62123 0.329634 9.91476C0.329634 15.2083 4.6211 19.4998 9.91463 19.4998C15.2082 19.4998 19.4996 15.2083 19.4996 9.91476C19.4996 4.62123 15.2082 0.329756 9.91463 0.329756ZM14.8631 12.8015C14.8631 13.3306 14.4179 13.7636 13.8735 13.7636H5.95573C5.41138 13.7636 4.96612 13.3306 4.96612 12.8015L4.97066 8.04803L9.79605 10.607C9.8326 10.6263 9.8733 10.6364 9.91463 10.6364C9.95596 10.6364 9.99667 10.6263 10.0332 10.607L14.8631 8.04562V12.8015ZM9.91702 9.70344L4.97122 7.01925C4.97602 6.49407 5.41458 6.0659 5.95575 6.0659H13.8736C14.4139 6.0659 14.8568 6.49247 14.8632 7.01658L9.91702 9.70344Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8039f9662153436f543598f432a0f596.svg";
export { ForwardRef as ReactComponent };